import { useState } from "react"
import { AdminUserAgent } from "../../api/adminUserAgent";
import { getTokenFromStorage } from "../../utils";

// Use this hook for user file upload for choosing user image

const useProfileImageUpload = () => {
    const [file, setFile] = useState(null);
    const [temporaryProfilePicture, setTemporaryProfilePicture] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);

        const reader = new FileReader();
        reader.onloadend = () => {
            setTemporaryProfilePicture(reader.result);
        };
        if (selectedFile) {
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSVGClick = () => {
        document.getElementById("fileInput").click();
    };

    const handleSubmit = async () => {
        if (!file) {
            console.error('No file selected.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        const token = getTokenFromStorage();

        try {
            await AdminUserAgent.setProfilePicture(token, formData);
            setFile(null);
            setTemporaryProfilePicture(null);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        file,
        temporaryProfilePicture,
        handleFileChange,
        handleSVGClick,
        handleSubmit
    };
};

export default useProfileImageUpload;